<template>
  <PopupTemplate @close="close()">
    <div v-if="!telEnviado">
      <h2>¡Te llamamos!</h2>
      <p>
        Por favor, confirmanos el teléfono en el que quieres recibir la llamada:
      </p>
      <form class="pure-form pure-form-aligned">
        <input
          id="telefono"
          v-model.trim="telefono"
          type="tel"
          class="pure-input"
          placeholder="Nº Teléfono sin espacios"
          maxlength="10"
          required
          @keydown="errorTelefono = null"
        />

        <div v-if="errorTelefono" class="telNoValido">{{ errorTelefono }}</div>

        <button
          type="submit"
          class="pure-button boton"
          title="Pulse el botón para ponernos en contacto contigo"
          @click.prevent="enviarFormulario"
        >
          Ok
        </button>
      </form>
    </div>

    <div v-else style="width:100%; margin-top:3rem;">
      <p>
        Gracias por solicitar información, con la máxima brevedad posible nos
        pondremos en contacto contigo.
      </p>
      <button
        type="submit"
        class="pure-button pure-button-primary"
        style="width:100%"
        @click.prevent="close()"
      >
        Ok
      </button>
    </div>
  </PopupTemplate>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable */

export default {
  props: {
    telefonoInic: { type: String, required: true, default: null },
    asuntoInic: { type: String, required: true, default: null },
  },

  data() {
    return {
      telefono: this.telefonoInic,
      asunto: this.asuntoInic,
      errorTelefono: null,
      telEnviado: false,
    };
  },

  created() {
    console.log(this.telefonoInic + " " + this.asuntoInic);
  },

  methods: {
    enviarFormulario: async function() {
      let expresionRegular = /^([9,7,6]{1})+([0-9]{8})$/;
      this.errorTelefono = "";

      if (this.telefono.length < 1) {
        this.errorTelefono = "Escriba un número de teléfono";
        return;
      }

      if (!expresionRegular.test(this.telefono)) {
        this.errorTelefono = "Número de telefono incorrecto";
        return;
      }

      this.telEnviado = true;

      console.log(
        "idWorkerPropio" +
          this.$store.state.portfolio.cliente.idWorkerPropioCliente,
        "idOwnerPropio" +
          this.$store.state.portfolio.cliente.idOwnerPropioCliente
      );

      let result = this.$store.dispatch("creaGestionClienteLlamame", {
        telefonoContacto: this.telefono,
        asunto: this.asunto,
        idWorkerPropio: this.$store.state.portfolio.cliente
          .idWorkerPropioCliente,
        idOwnerPropio: this.$store.state.portfolio.cliente.idOwnerPropioCliente,
      });

      console.log(result);
      if (result.codigo != 0) {
        this.errorTelefono = "Se ha producido un error. Intentelo más tarde";
        return;
      }
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.boton {
  background-color: $colorMMT;
  border-radius: 5px;
  margin-top: 1rem;
  color: white;
  font-weight: bold;
  width: 100%;
}

input {
  width: 100%;
  min-width: 15rem;
}

.telNoValido {
  color: red;
  font-weight: bold;
}
</style>
